/* Soleil d'Or — volet de filtres Search & Discovery (maquette v6, octobre 2026)
   - Coche / prix / tri : la grille se met à jour sans recharger la page
     (rendu de section Shopify), l'adresse suit (partage, retour arrière).
   - Ordinateur : filtres masqués à chaque chargement de page (grille en
     4 colonnes) ; « Afficher les filtres » les ouvre pour la visite en cours.
   - Prix : curseur à deux poignées (min / max) au-dessus des deux champs
     du filtre prix Search & Discovery ; on peut glisser ou taper un montant,
     les deux restent synchronisés.
   - Un seul groupe de filtres ouvert à la fois (accordéon).
   - Tri « Selon mon profil olfactif » : proposé seulement si un profil existe.
   - Mobile : le volet s'ouvre en tiroir. Échap ou × pour fermer. */
(function () {
  'use strict';
  var SEL = '[data-sdo-volet-section]';
  var affiche = false;
  var html = document.documentElement;
  var requete = null;
  var minuterie = null;
  var historique = false;
  var triProfil = false;

  function racine() { return document.querySelector(SEL); }

  function appliquerMasque(r) {
    var vf = r && r.querySelector('[data-sdo-vf]');
    if (!vf) return;
    vf.classList.toggle('is-affiche', affiche);
    var b = vf.querySelector('[data-sdo-vf-basculer]');
    if (b) b.setAttribute('aria-expanded', affiche ? 'true' : 'false');
  }

  /* Aperçu d'un modèle alternatif (?view=…) : on garde le paramètre */
  function garderVue(url) {
    var vue = new URLSearchParams(location.search).get('view');
    if (!vue || /[?&]view=/.test(url)) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'view=' + encodeURIComponent(vue);
  }

  function adresse(form) {
    var sp = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '' && !(k === 'sort_by' && v === 'sdo-profil')) sp.append(k, v); });
    var q = sp.toString();
    /* chemin courant : garde la page marque × note (/collections/x/note-…) */
    return location.pathname + (q ? '?' + q : '');
  }

  function ouvrir(oui) {
    html.classList.toggle('sdo-vf-ouvert', oui);
    var b = document.querySelector('[data-sdo-vf-ouvrir]');
    if (b) b.setAttribute('aria-expanded', oui ? 'true' : 'false');
  }

  function charger(url, pousser) {
    var r = racine();
    url = garderVue(url);
    if (!r) { location.href = url; return; }
    var id = r.getAttribute('data-sdo-volet-section');
    var ouverts = {};
    r.querySelectorAll('[data-sdo-vf-groupe]').forEach(function (d) {
      ouverts[d.getAttribute('data-sdo-vf-groupe')] = { open: d.open, plus: d.classList.contains('is-plus') };
    });
    var volet = r.querySelector('.sdo-vf__volet');
    var defil = volet ? volet.scrollTop : 0;
    r.classList.add('is-chargement');
    if (requete && requete.abort) requete.abort();
    requete = window.AbortController ? new AbortController() : null;
    var u = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(id);
    fetch(u, { signal: requete ? requete.signal : undefined, credentials: 'same-origin' })
      .then(function (rep) { if (!rep.ok) throw new Error(rep.status); return rep.text(); })
      .then(function (texte) {
        var doc = new DOMParser().parseFromString(texte, 'text/html');
        var neuf = doc.querySelector(SEL);
        if (!neuf) { location.href = url; return; }
        neuf.querySelectorAll('[data-sdo-vf-groupe]').forEach(function (d) {
          var e = ouverts[d.getAttribute('data-sdo-vf-groupe')];
          if (!e) return;
          d.open = e.open;
          if (e.plus) deplier(d);
        });
        /* on garde l'ancien <product-grid-container> (et on y verse le nouveau
           contenu) : sdo-ruptures-en-dernier.js le surveille ; s'il était
           remplacé, ce script continuerait sur l'ancienne grille, bloquerait
           « Voir plus » et fausserait le nombre de parfums affichés */
        var ancienC = r.querySelector('product-grid-container');
        r.replaceWith(neuf);
        var neufC = neuf.querySelector('product-grid-container');
        if (ancienC && neufC) {
          for (var i = 0; i < neufC.attributes.length; i++) {
            ancienC.setAttribute(neufC.attributes[i].name, neufC.attributes[i].value);
          }
          neufC.replaceWith(ancienC);
          ancienC.replaceChildren.apply(ancienC, Array.prototype.slice.call(neufC.childNodes));
        }
        appliquerMasque(neuf);
        curseurs(neuf);
        progres(neuf);
        optionProfil(neuf);
        if (triProfil) trierProfil();
        var v2 = neuf.querySelector('.sdo-vf__volet');
        if (v2) v2.scrollTop = defil;
        if (pousser) { history.pushState({ sdoVolet: true }, '', url); historique = true; }
        var haut = neuf.getBoundingClientRect().top;
        if (haut < 0 && !html.classList.contains('sdo-vf-ouvert')) {
          window.scrollTo({ top: window.pageYOffset + haut - 80, behavior: 'smooth' });
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = url;
      });
  }

  function curseurs(zone) {
    (zone || document).querySelectorAll('.sdo-vf__prix').forEach(function (bloc) {
      var avant = bloc.previousElementSibling;
      if (avant && avant.classList.contains('sdo-vf__curseur')) return;
      var champs = bloc.querySelectorAll('input[type="number"]');
      if (champs.length < 2) return;
      var mini = champs[0];
      var maxi = champs[1];
      var max = parseInt(maxi.getAttribute('max'), 10) || 0;
      if (max < 1) return;
      var a0 = parseInt(mini.value, 10);
      var b0 = parseInt(maxi.value, 10);
      var c = document.createElement('div');
      c.className = 'sdo-vf__curseur';
      c.innerHTML = '<div class="sdo-vf__piste"><span class="sdo-vf__plage"></span></div>' +
        '<input type="range" class="sdo-vf__r" min="0" max="' + max + '" step="1" aria-label="Prix minimum">' +
        '<input type="range" class="sdo-vf__r" min="0" max="' + max + '" step="1" aria-label="Prix maximum">' +
        '<p class="sdo-vf__bornes"><span></span><span></span></p>';
      bloc.parentNode.insertBefore(c, bloc);
      var r = c.querySelectorAll('.sdo-vf__r');
      var ra = r[0];
      var rb = r[1];
      var plage = c.querySelector('.sdo-vf__plage');
      var bornes = c.querySelectorAll('.sdo-vf__bornes span');
      ra.value = isNaN(a0) ? 0 : a0;
      rb.value = isNaN(b0) ? max : b0;
      function peindre() {
        var a = +ra.value;
        var b = +rb.value;
        plage.style.left = (a / max * 100) + '%';
        plage.style.right = (100 - b / max * 100) + '%';
        bornes[0].textContent = a + ' €';
        bornes[1].textContent = b + ' €';
        ra.setAttribute('aria-valuetext', a + ' euros');
        rb.setAttribute('aria-valuetext', b + ' euros');
        ra.style.zIndex = a > max * 0.9 ? 3 : 2;
      }
      function bouger(e) {
        if (+ra.value > +rb.value) {
          if (e.target === ra) ra.value = rb.value; else rb.value = ra.value;
        }
        peindre();
        reporter();
      }
      /* les champs suivent le curseur ; au lâcher, l'écouteur « change »
         du document recharge la grille */
      function reporter() {
        mini.value = +ra.value > 0 ? ra.value : '';
        maxi.value = +rb.value < max ? rb.value : '';
      }
      /* saisie au clavier dans les champs : le curseur suit */
      function suivre() {
        var a = parseInt(mini.value, 10);
        var b = parseInt(maxi.value, 10);
        ra.value = isNaN(a) ? 0 : Math.min(Math.max(a, 0), max);
        rb.value = isNaN(b) ? max : Math.min(Math.max(b, 0), max);
        peindre();
      }
      mini.addEventListener('input', suivre);
      maxi.addEventListener('input', suivre);
      ra.addEventListener('input', bouger);
      rb.addEventListener('input', bouger);
      ra.addEventListener('change', reporter);
      rb.addEventListener('change', reporter);
      peindre();
    });
  }

  /* « 24 sur 33 parfums » : suit le nombre de vignettes après « Voir plus » */
  function progres(zone) {
    var p = (zone || document).querySelector('[data-sdo-vf-progres] [data-n]');
    var liste = (zone || document).querySelector('#data-pagination');
    if (!p || !liste || !window.MutationObserver) return;
    var bloc = p.closest('#component-pagination-loader');
    /* total de la collection, lu dans « 24 sur 33 parfums » */
    var total = parseInt(((p.parentNode.textContent.split(/ (?:sur|of) /)[1]) || '').replace(/[^0-9]/g, ''), 10) || 0;
    /* numéros de page : gardés dans le code pour les moteurs, masqués à l'écran
       (« Voir plus » suffit) */
    if (bloc) bloc.querySelectorAll('.pagination-wrapper').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
    function compter() {
      /* seules les vignettes affichées comptent : sdo-ruptures-en-dernier.js
         précharge des pages et garde des cartes en réserve (masquées) */
      var vus = 0;
      liste.querySelectorAll('.data-pagination__item').forEach(function (li) {
        if (!li.classList.contains('sdo-carte-en-attente') && !li.classList.contains('sdo-rupture-differee')) vus++;
      });
      p.textContent = vus;
      /* tout est affiché : plus de « Voir plus » ni de numéros (le thème les laissait) */
      var cur = bloc && bloc.querySelector('[data-current-page]');
      var tot = bloc && bloc.querySelector('[data-total-pages]');
      if (cur && tot && +cur.value >= +tot.value && (!total || vus >= total)) {
        bloc.querySelectorAll('pagination-loader, .pagination-wrapper').forEach(function (el) { el.hidden = true; el.style.display = 'none'; });
      }
    }
    compter();
    new MutationObserver(function () { setTimeout(compter, 0); }).observe(liste, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function deplier(groupe) {
    groupe.querySelectorAll('.sdo-vf__plus').forEach(function (li) { li.hidden = false; });
    groupe.classList.add('is-plus');
    var b = groupe.querySelector('[data-sdo-vf-plus]');
    if (b) b.remove();
  }

  function formDe(el) {
    if (el.form && el.form.matches('[data-sdo-vf-form]')) return el.form;
    return null;
  }

  document.addEventListener('change', function (e) {
    var form = formDe(e.target);
    if (!form) return;
    if (e.target.name === 'sort_by') {
      if (e.target.value === 'sdo-profil') {
        triProfil = true;
        clearTimeout(minuterie);
        trierProfil();
        return;
      }
      triProfil = false;
    }
    clearTimeout(minuterie);
    minuterie = setTimeout(function () { charger(adresse(form), true); }, e.target.type === 'checkbox' ? 120 : 0);
  });

  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-sdo-vf-form]')) return;
    e.preventDefault();
    charger(adresse(e.target), true);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sdo-vf-lien], [data-sdo-vf-plus], [data-sdo-vf-ouvrir], [data-sdo-vf-fermer], [data-sdo-vf-basculer], .sdo-vf__voile');
    if (!t) return;
    if (t.hasAttribute('data-sdo-vf-lien')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      e.preventDefault();
      charger(t.getAttribute('href'), true);
    } else if (t.hasAttribute('data-sdo-vf-plus')) {
      deplier(t.closest('[data-sdo-vf-groupe]'));
    } else if (t.hasAttribute('data-sdo-vf-ouvrir')) {
      ouvrir(true);
    } else if (t.hasAttribute('data-sdo-vf-fermer') || t.classList.contains('sdo-vf__voile')) {
      ouvrir(false);
    } else if (t.hasAttribute('data-sdo-vf-basculer')) {
      affiche = !affiche;
      appliquerMasque(racine());
    }
  });

  /* accordéon : ouvrir un groupe de filtres referme les autres */
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.sdo-vf__groupe > summary');
    if (!s) return;
    var d = s.parentNode;
    if (d.open) return;
    var form = d.closest('[data-sdo-vf-form]');
    if (!form) return;
    form.querySelectorAll('.sdo-vf__groupe[open]').forEach(function (o) { if (o !== d) o.open = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && html.classList.contains('sdo-vf-ouvert')) ouvrir(false);
  });

  window.addEventListener('popstate', function (e) {
    if (historique || (e.state && e.state.sdoVolet)) location.reload();
  });

  function entete() {
    var h = document.querySelector('.shopify-section-header');
    if (!h) return;
    function maj() { html.style.setProperty('--sdo-hh', h.offsetHeight + 'px'); }
    maj();
    window.addEventListener('resize', maj);
  }

  /* -------------------------------------------------------------------------
     Tri « Selon mon profil olfactif ». Rien n'est envoyé au serveur ni stocké :
     on lit les suggestions du profil (client connecté, balise
     #sdo-profil-suggestions) et les familles déjà relevées par
     assets/sdo-profil-local.js (sdo_profil_v1). Toute la collection filtrée
     est chargée puis réordonnée ; « Voir plus » dévoile ensuite 24 par 24.
  ------------------------------------------------------------------------- */
  function profil() {
    var s = [];
    var t = document.getElementById('sdo-profil-suggestions');
    if (t) { try { s = JSON.parse(t.textContent) || []; } catch (e) { s = []; } }
    var f = {};
    var aFam = false;
    try {
      var o = JSON.parse(window.localStorage.getItem('sdo_profil_v1') || 'null');
      if (o && o.f && o.t && Date.now() - o.t < 120 * 864e5) {
        f = o.f;
        for (var k in f) { if (f[k] > 0) { aFam = true; break; } }
      }
    } catch (e) {}
    if (!s.length && !aFam) return null;
    return { s: s, f: f };
  }

  function optionProfil(r) {
    var opt = r && r.querySelector('option[value="sdo-profil"]');
    if (!opt) return;
    var ok = !!profil();
    opt.hidden = !ok;
    opt.disabled = !ok;
    if (ok && triProfil) opt.selected = true;
  }

  function noter(li, p) {
    var h = li.getAttribute('data-sdo-handle') || '';
    var i = h ? p.s.indexOf(h) : -1;
    if (i > -1) return 100000 - i;
    var fams = (li.getAttribute('data-sdo-familles') || '').split('|');
    var sc = 0;
    for (var k = 0; k < fams.length; k++) {
      var nom = fams[k].trim();
      if (nom && p.f[nom]) sc += p.f[nom];
    }
    return sc;
  }

  function trierProfil() {
    var r = racine();
    var p = profil();
    if (!r || !p) return;
    var id = r.getAttribute('data-sdo-volet-section');
    var liste = r.querySelector('ul#data-pagination');
    if (!liste) return;
    var bloc = r.querySelector('#component-pagination-loader');
    var totEl = bloc && bloc.querySelector('[data-total-pages]');
    var curEl = bloc && bloc.querySelector('[data-current-page]');
    var nextEl = bloc && bloc.querySelector('[data-next-url]');
    var total = totEl ? (parseInt(totEl.value, 10) || 1) : 1;
    var cur = curEl ? (parseInt(curEl.value, 10) || 1) : 1;
    var base = location.pathname + location.search.replace(/([?&])page=[0-9]+&?/, '$1').replace(/[?&]$/, '');
    var pages = [];
    for (var n = cur + 1; n <= Math.min(total, 20); n++) pages.push(n);
    r.classList.add('is-chargement');
    Promise.all(pages.map(function (num) {
      var u = base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + num + '&section_id=' + encodeURIComponent(id);
      return fetch(u, { credentials: 'same-origin' })
        .then(function (rep) { return rep.ok ? rep.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (textes) {
      var deja = {};
      liste.querySelectorAll('[data-product-id]').forEach(function (li) { deja[li.getAttribute('data-product-id')] = 1; });
      var frag = document.createDocumentFragment();
      textes.forEach(function (texte) {
        if (!texte) return;
        var doc = new DOMParser().parseFromString(texte, 'text/html');
        doc.querySelectorAll('#data-pagination .data-pagination__item').forEach(function (li) {
          var pid = li.getAttribute('data-product-id');
          if (pid && deja[pid]) return;
          if (pid) deja[pid] = 1;
          frag.appendChild(li);
        });
      });
      if (pages.length) {
        liste.appendChild(frag);
        if (nextEl) nextEl.value = '';
        if (curEl) curEl.value = total;
      }
      /* tri stable : à score égal, l'ordre de la collection est conservé ;
         les tuiles éditoriales passent après les parfums */
      var notes = Array.prototype.slice.call(liste.children).map(function (el, i) {
        var prod = el.classList.contains('data-pagination__item') ? 1 : 0;
        return { el: el, rang: i, prod: prod, sc: prod ? noter(el, p) : 0 };
      });
      notes.sort(function (a, b) {
        if (b.prod !== a.prod) return b.prod - a.prod;
        if (b.sc !== a.sc) return b.sc - a.sc;
        return a.rang - b.rang;
      });
      var f2 = document.createDocumentFragment();
      notes.forEach(function (x) { f2.appendChild(x.el); });
      liste.appendChild(f2);
      r.classList.remove('is-chargement');
    });
  }

  function demarrer() { entete(); appliquerMasque(racine()); curseurs(); progres(); optionProfil(racine()); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer, { once: true });
  } else {
    demarrer();
  }
})();